import React from 'react';
import { motion } from 'framer-motion';
import Recap from './Recap';
import ResultItems from './ResultItems';
import { LoadingState, ResultsHeader } from './partials';
import ErrorState from '@client/components/shared/ErrorState';


const Result = ({
  filters,
  searchData,
  data,
  isLoading,
  error,
  getFilterLabel,
  onResetFilters,
  onRemoveFilter,
  onPageChange,
  onSortChange,
  currentSorting,
  onShare,
  onFiltersFromURL,
}) => {
  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState error={error} />;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1],
      }}
    >
      <ResultsHeader data={data} onShare={onShare} onPageChange={onPageChange} />
      <Recap
        filters={filters}
        data={data}
        onResetFilters={onResetFilters}
        onRemoveFilter={onRemoveFilter}
        getFilterLabel={getFilterLabel}
        onFiltersFromURL={onFiltersFromURL}
      />

      <ResultItems
        data={data}
        filters={filters}
        searchData={searchData}
        onPageChange={onPageChange}
        onSortChange={onSortChange}
        currentSorting={currentSorting}
      />
    </motion.div>
  );
};

export default React.memo(Result);
